import React from 'react';
import './search.css'
import Btn1 from '../../fay/common/btn1';

const Search = () => {
    return ( 
        <div className='search'>
            <h5 className='searchtext'>Enter location, city, or neighborhood</h5>
            <Btn1
                    btn1style="btn-brown"
                    btntext="Search"
                    />
        </div>
     );
}
 
export default Search;